import { createContext } from 'react';

import { ConsentStore } from '../consent';

export default createContext<ConsentStore | {}>({});
